import React, { useEffect } from "react";
import ProjectsTable from "../ProjectsTable";
import Header from "../Header";
import Button from "../Partial/Button";
import CreateProjectModal from "./CreateProjectModal";
import useProject from "./useProject";
import I1 from "../../assets/Icons/SwitchIcons/Icons-1.svg"; // Add this import
import LoadIcon from "../LoadIcon";
import { useSelector } from "react-redux";

function Home() {
  const { projects, isModalOpen, toggleModal, handleDelete } = useProject();

  return (
    <div className="flex flex-col">
      <Header />
      <div className="w-full flex justify-center items-center mt-28">
        <div className="w-[95%] flex flex-col gap-6">
          <div className="flex justify-between items-center">
            <p className="text-2xl">Project</p>
            {/* <LoadIcon svgContent={I1} /> */}
            <Button
              text="Create Project"
              onClick={toggleModal}
              className="px-10 py-3"
            />
          </div>

          <ProjectsTable projects={projects} handleDelete={handleDelete} />
        </div>
      </div>

      {isModalOpen && <CreateProjectModal onClose={toggleModal} />}
    </div>
  );
}

export default Home;
